import React from 'react';
import SVGInline from 'react-svg-inline';

const Titulin = props => {
	return (
		<div className="titulinCont">
			<p
				className={`titulin ${props.rank ? 'favorita' : ''}`}
				style={{ marginTop: '1em', fontSize: '1.4em', fontWeight: '500' }}
			>
				{props.titulo}
				{props.rank ? (
					<span className="agr_favorita">
						<SVGInline
							className="star"
							svg={`<svg id="star" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 19">
  <path fill="${
		props.color
	}" d="M12 .5L14.9 9h8.7l-7 5.4 2.6 8.2-7.2-4.9-7.2 4.9 2.6-8.2L.4 9h8.7z"/>
</svg>`}
						/>{' '}
						Favorita
					</span>
				) : (
					''
				)}
			</p>
		</div>
	);
};

export default Titulin;



// WEBPACK FOOTER //
// ./src/components/Titulin.js